import { Link, useParams } from 'react-router-dom';
import { useGetRelationGroupOverviewDetailQuery } from 'services';
import { Button, Result } from 'antd';
import { CircularProgress } from 'components';

import SearchArticle from '../search-article';

import BackButton from './back-button';
import ArticleRelationTable from './article-relation-table';
import PageTitle from './page-title';
import DecisionCheckbox from './decision-checkbox';

function ArticleRelationManagement({ onSelect }) {
  const { uid } = useParams();
  const { data, isLoading, isError } = useGetRelationGroupOverviewDetailQuery({ uid });

  if (isLoading) return <CircularProgress />;

  if (isError || !data) {
    return (
      <Result
        status="500"
        title="Hata"
        subTitle="İlişki detayı yüklenirken bir hata oluştu."
        extra={
          <Link to="/madde-iliskilendirme-yonetimi">
            <Button type="primary">Geri Dön</Button>
          </Link>
        }
      />
    );
  }

  return (
    <div>
      <div>
        <BackButton />
        <div className="gx-d-flex gx-align-items-center gx-justify-content-between">
          <PageTitle
            articleTitle={data.title}
            articleSource={data.type}
            resourceUrl={data.resourceUrl}
            isAbandoned={data.isAbandoned}
          />
          <DecisionCheckbox data={data} uid={uid} />
        </div>
        <SearchArticle onSelect={onSelect} excludeId={`${data.type}-${data.originalId}`} />
        <ArticleRelationTable
          baseType={data.type}
          baseId={data.originalId}
        />
      </div>
    </div>
  );
}

export default ArticleRelationManagement;
